import { ReactNode } from 'react';
import { Box } from '@apia/theme';
import { RequiredLbl } from '.';

const RequiredBox = ({
  labelNode,
  label,
  avoidColon,
  required,
  isFormReadonly = false,
}: {
  /**
   * Permite el pasaje de un Nodo JSX arbitrario, si se pasa este prop, no se
   * mostrará el label y el semicolon solo se mostrara si avoidColon se pasa
   * como false
   */
  labelNode?: ReactNode;
  label?: string;
  avoidColon?: boolean;
  required?: boolean;
  isFormReadonly?: boolean;
}) => {
  return (
    <Box
      className="fieldLabel__container"
      as="span"
      {...window.getVariant('layout.common.components.fieldLabelBox')}
    >
      {window.SHOW_REQUIRED_POSITION !== '0' && (
        <RequiredLbl required={required} isFormReadonly={isFormReadonly} />
      )}
      {!labelNode && <>{label}</>}
      {labelNode}
      {!avoidColon && ':'}
      {window.SHOW_REQUIRED_POSITION === '0' && (
        <RequiredLbl required={required} isFormReadonly={isFormReadonly} />
      )}
    </Box>
  );
};

export default RequiredBox;
